export default {
  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: Array,
      default: () => []
    },
    counter: {
      type: Number,
      default: 10
    }
  },

  data: () => ({
    search: ''
  }),

  computed: {
    menuProps() {
      const disabled = this.value.length >= this.counter;

      return { disabled };
    },

    listeners: function() {
      return Object.assign({}, this.$listeners, {
        change: [this.clearSearch, this.emitter],
        'click:append-outer': this.clearFilter
      });
    }
  },

  methods: {
    clearSearch() {
      this.search = '';
    },

    removeItem(id) {
      this.emitter(this.value.filter(i => i !== id));
    },

    clearFilter() {
      this.emitter([]);
    },

    emitter(data) {
      this.$emit('input', data);
      this.$emit('change', data);
    }
  }
};
